import React, { useContext } from 'react'
import { store } from '../../stores/pages'
import { Button } from 'reactstrap'
import classNames from 'classnames'

export default function SidebarNav() {
  const { themeEditor, themeOnly, dispatch, actions } = useContext(store)

  const pageClasses = classNames({
    "nav-link": true,
    "active": !themeEditor,
  })

  const themeClasses = classNames({
    "nav-link": true,
    "active": themeEditor,
  })

  const togglePageEditor = () => {
    dispatch({ type: actions.TOGGLE_PAGE_EDITOR })
  }

  const toggleThemeEditor = () => {
    dispatch({ type: actions.TOGGLE_THEME_EDITOR })
  }

  return (
    <ul className="nav-toptab nav px-2">
      {!themeOnly && (<li className="nav-item">
        <Button color="link" className={pageClasses} onClick={togglePageEditor}>
          Page Editor
        </Button>
      </li>)}
      <li className="nav-item">
        <Button color="link" className={themeClasses} onClick={toggleThemeEditor}>
          Theme Editor
        </Button>
      </li>
    </ul>
  )
}
